var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPremiumFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02632 7.96553L5 6.46158L6.97368 7.96553L6.23487 5.52224L8.20342 4.12355H5.79145L5 1.55868L4.20855 4.12355H1.79658L3.76513 5.52224L3.02632 7.96553ZM5.00092 10C4.30934 10 3.6593 9.86877 3.05079 9.60632C2.44228 9.34386 1.91298 8.98768 1.46289 8.53776C1.01281 8.08785 0.656447 7.55877 0.393816 6.95053C0.131272 6.34228 0 5.69241 0 5.00092C0 4.30934 0.131228 3.6593 0.393684 3.05079C0.65614 2.44228 1.01232 1.91298 1.46224 1.46289C1.91215 1.01281 2.44123 0.656447 3.04947 0.393816C3.65772 0.131272 4.30759 0 4.99908 0C5.69066 0 6.3407 0.131228 6.94921 0.393684C7.55772 0.65614 8.08702 1.01232 8.53711 1.46224C8.98719 1.91215 9.34355 2.44123 9.60618 3.04947C9.86873 3.65772 10 4.30759 10 4.99908C10 5.69066 9.86877 6.3407 9.60632 6.94921C9.34386 7.55772 8.98768 8.08702 8.53776 8.53711C8.08785 8.98719 7.55877 9.34355 6.95053 9.60618C6.34228 9.86873 5.69241 10 5.00092 10Z",
    fill: "#E88053"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPremiumFeature);
export default __webpack_public_path__ + "static/media/icon-premium-feature.f56e00d83062ef9a1766f2f1bf0bb357.svg";
export { ForwardRef as ReactComponent };